// @ts-nocheck
import PropTypes from 'prop-types';
import './SegmentedToggle.css';

const SegmentedToggle = ({
  options = [],
  selectedValue,
  onChange,
  disabled = false,
  className = ''
}) => {
  return (
    <div
      className={['segmented-toggle', className].filter(Boolean).join(' ')}
      role='group'
    >
      {options.map((option) => {
        const isActive =
          option?.value === selectedValue ||
          option?.matchValues?.includes(selectedValue);

        return (
          <button
            key={option?.value}
            type='button'
            className={`segmented-toggle__button${
              isActive ? ' segmented-toggle__button--active' : ''
            }`}
            onClick={() => onChange?.(option?.value)}
            disabled={disabled}
            aria-pressed={isActive}
          >
            {option?.label}
          </button>
        );
      })}
    </div>
  );
};

SegmentedToggle.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.string,
      matchValues: PropTypes.arrayOf(PropTypes.string)
    })
  ),
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

export default SegmentedToggle;
